export const MobileRow = ({
  icon,
  label,
  value,
}: {
  icon: React.ReactNode;
  label: string;
  value: React.ReactNode;
}) => (
  <div className="flex items-start gap-2">
    <div className="mt-1 text-lg">{icon}</div>
    <div className="text-sm text-gray-700">
      <div className="font-medium text-gray-900">{label}</div>
      <div>{value}</div>
    </div>
  </div>
);
